<template>
  <div>
    <v-text-field
      class="input-exam"
      v-model="selectedTitle"
      color="secondary"
      :rules="rules"
      dense
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        value => value && value.length <= 37 || `全角３７文字以内で入力してください`,
      ],
    }
  },
  computed: {
    selectedTitle: {
      get() {
        return this.$store.state.sheet.title
      },
      set(value) {
        this.$store.commit('sheet/setTitle', { title: value })
        this.$emit('changeTitle')
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-exam
  margin-top 30px
  width 300px
.input-exam
  width 300px
</style>>
